<template>
  <div>
    <!-- Modelo de página -->
    <div class="theme-page-section theme-page-section-gray theme-page-section-lg">
      <div class="container">
        <div class="row mt-90">
          <!-- Menu -->
          <account-menu />
          <!-- /Menu -->
          <div
            v-if="company"
            class="col-md-10">
            <!-- Titulo -->
            <h1 class="theme-account-page-title">Empresa</h1>
            <!-- /Titulo -->
            <company-register
              :canEdit="user && (user.isManager || user.isAdmin)"
              :id="`${company.id}`"
              class="row">
              <template v-slot:default>
                <div class="col-xs-6"></div>
              </template>
            </company-register>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modelo de página -->
    <lock-screen :loading="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountMenu from "@/components/template/AccountMenu";
import CompanyRegister from "@/components/forms/CompanyRegister";
import LockScreen from "@/components/lockscreen/index.vue";

export default {
  components: {
    AccountMenu,
    CompanyRegister,
    LockScreen
  },
  computed: {
    ...mapState('auth', ['user', 'company']),
    ...mapState('companies', ['loading', 'alert'])
  },
  watch: {
    alert (data) {
      if (data) {
        this.$swal({
          title: data,
          type: 'success',
          confirmButtonText: 'SAIR'
        });
      }
    }
  }
};
</script>
